export default "__VITE_ASSET__2f9eb179__"